import { render, staticRenderFns } from "./ProductRadar.vue?vue&type=template&id=0a425536&scoped=true&"
import script from "./ProductRadar.vue?vue&type=script&lang=js&"
export * from "./ProductRadar.vue?vue&type=script&lang=js&"
import style0 from "./ProductRadar.vue?vue&type=style&index=0&id=0a425536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a425536",
  null
  
)

/* custom blocks */
import block0 from "./ProductRadar.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardSubtitle})
